<template>
    <section>
        <article class="w-full items-center mx-auto p-6 pt-2" v-if="isLoading">
            <svg
                class="flex animate-spin h-6 w-6 mt-5 ml-2 text-blue items-center"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
            >
                <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                />
                <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
            </svg>
        </article>

        <div
            class="flex items-center bg-blue-500 text-white text-sm font-bold px-4 py-3 mx-4 mt-4 m mb-4"
            role="alert"
            v-if="showPinnedChats && chatbox != 'pinned-full'"
        >
            <svg
                class="fill-current w-4 h-4 mr-2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
            >
                <path
                    d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"
                />
            </svg>
            <p>{{ t("tts.chats.pinned-chats") }}</p>
        </div>

        <ul
            class="divide-y divide-gray-200 overflow-y-auto scroll-smooth"
            style="height: calc(100vh - 150px)"
            ref="chatList"
        >
            <transition-group name="chat-fade">
            <li
                class="px-6 py-5 relative"
                v-for="(chat, index) in allChats"
                :key="chat.id || index"
                v-show="chat.message != '...' && chat.user"
                :class="{ 'bg-yellow-50': chat.is_pinned && can_moderate }"
            >
                <div
                    class="absolute right-0 inline-block text-left z-20 mr-1"
                    v-if="can_moderate && chat.user"
                >
                    <button
                        @click="
                            chatOption == chat.id
                                ? (chatOption = false)
                                : (chatOption = chat.id)
                        "
                        class="group relative w-8 h-8 inline-flex items-center justify-center focus:outline-none"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span
                            class="flex items-center justify-center h-full w-full rounded-full group-focus:bg-gray-200 transition ease-in-out duration-150"
                        >
                            <svg
                                class="w-5 h-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                                />
                            </svg>
                        </span>
                    </button>

                    <!-- <transition
                        enter-active-class="transition ease-out duration-100"
                        enter-class="transform opacity-0 scale-95"
                        enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95"
                    > -->
                    <div
                        class="origin-bottom-right absolute z-10 top-0 right-9 w-48 rounded-md shadow-lg"
                        v-if="chatOption == chat.id"
                    >
                        <div class="rounded-md bg-white shadow-xs">
                            <div
                                class="py-1"
                                role="menu"
                                aria-orientation="vertical"
                            >
                                <a
                                    @click="pinChat(chat)"
                                    v-if="!chat.is_invited || !workshop"
                                    class="cursor-pointer block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                    role="menuitem"
                                >
                                    <span v-if="!chat.is_pinned">{{
                                        t("tts.chats.pin")
                                    }}</span>
                                    <span v-if="chat.is_pinned">{{
                                        t("tts.chats.unpin")
                                    }}</span>
                                </a>
                                <a
                                    v-if="!chat.is_invited && !workshop"
                                    @click="joinTalk(chat)"
                                    class="cursor-pointer block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                    role="menuitem"
                                >
                                    {{
                                        t(
                                            "chat.invite",
                                            "Uitnodigen voor gesprek"
                                        )
                                    }}
                                </a>

                                <a
                                    v-if="
                                        chat.is_invited && backstage == 'active'
                                    "
                                    @click="fetchBack(chat)"
                                    class="cursor-pointer block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                    role="menuitem"
                                >
                                    {{
                                        t(
                                            "chat.out-of-backstage",
                                            "Terughalen uit Backstage"
                                        )
                                    }}
                                </a>

                                <a
                                    @click="blockUser(chat)"
                                    v-if="!chat.user.is_blocked"
                                    class="cursor-pointer block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                    role="menuitem"
                                >
                                    {{ t("chat.block", "Blokkeer deelnemer") }}
                                </a>

                                <a
                                    @click="deleteChat(chat)"
                                    class="cursor-pointer block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                    role="menuitem"
                                    >{{ t("tts.chats.delete") }}</a
                                >
                            </div>
                        </div>
                    </div>
                    <!-- </transition> -->
                </div>
                <div
                    class="group flex justify-between items-center space-x-2"
                    v-if="chat.user"
                >
                    <div class="-m-1 p-1 block">
                        <span
                            class="absolute inset-0 NOT-group-hover:bg-gray-50"
                        ></span>

                        <div
                            class="flex-1 flex items-center min-w-0 relative"
                            v-if="chat.user"
                        >
                            <span class="flex-shrink-0 inline-block relative">
                                <img
                                    class="h-8 w-8 rounded-full"
                                    :src="chat.user.avatar"
                                    alt
                                />
                                <span
                                    class="absolute top-0 right-0 block h-2.5 w-2.5 rounded-full text-white shadow-solid bg-green-400 hidden"
                                ></span>
                            </span>
                            <div class="ml-4">
                                <div
                                    class="text-sm leading-5 font-medium text-gray-900"
                                >
                                    <p>{{ chat.message }}</p>
                                </div>
                                <div
                                    class="text-sm leading-5 text-gray-500"
                                    :title="chat.user.tagline"
                                >
                                    {{ chat.user.name_chat }}
                                    <span
                                        v-if="chat.user.is_moderator"
                                        class="text-xs"
                                        >&bull;</span
                                    >
                                    <span
                                        class="text-xs font-medium text-teal-500 lowercase"
                                        v-if="chat.user.is_moderator"
                                        >&nbsp;{{
                                            t(
                                                "user.role.moderator",
                                                "moderator"
                                            )
                                        }}</span
                                    >
                                    <span
                                        v-if="
                                            chat.is_invited &&
                                            backstage == 'active'
                                        "
                                        class="text-xs"
                                        >&bull;</span
                                    >
                                    <span
                                        class="text-xs font-medium text-blue-500"
                                        v-if="
                                            chat.is_invited &&
                                            backstage == 'active'
                                        "
                                        >&nbsp;{{
                                            t(
                                                "user.is_invited",
                                                "neemt deel aan sessie"
                                            )
                                        }}</span
                                    >
                                    <span
                                        class="text-xs"
                                        :title="chat.created_at"
                                    >
                                        &bull;
                                        <span> {{ chat.ago }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            </transition-group>
        </ul>

        <section
            class="h-auto flex-shrink-0 flex-col px-4 py-4 pt-6 space-x-4 flex justify-end bg-gray-100 w-auto border-t border-gray-200 shadow-lg"
            v-show="!showPinnedChats"
        >
            <div
                class="bg-blue-100 border-t border-b border-blue-500 text-blue-700 shadow-md"
                :class="{
                    '-mt-4 mb-3 py-2 px-4 ml-3': isModerator,
                    ' px-4 py-3': !isModerator,
                }"
                role="alert"
                v-if="chatBoxStatus != 'open'"
            >
                <p class="text-sm">{{ t("tts.chats.is-closed") }}</p>
            </div>
            <div v-show="chatBoxStatus == 'open' || isModerator">
                <div class="mt-0 mb-2 flex rounded-md shadow-sm">
                    <div class="relative flex-grow focus-within:z-10">
                        <input
                            id="message"
                            type="text"
                            autocomplete="off"
                            v-model="message"
                            @keyup.enter="newChat"
                            @input="isTyping"
                            class="form-input block w-full rounded-none rounded-l-md transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            maxlength="50000"
                            :placeholder="t('tts.chats.your-message')"
                        />
                    </div>
                    <button
                        class="-ml-px relative inline-flex items-center px-4 py-2 border border-blue-600 text-sm leading-5 font-medium rounded-r-md text-blue-50 bg-blue-400 hover:text-blue-600 hover:bg-blue-900 focus:outline-none focus:shadow-outline-blue focus:border-blue-700 active:bg-blue-500 active:text-blue-700 transition ease-in-out duration-150 tts-button"
                        @click="newChat()"
                        :disabled="isSending"
                    >
                        <svg
                            v-if="isSending"
                            class="flex animate-spin h-5 w-5 text-blue-50 items-center tts-button-text"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                class="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="4"
                            />
                            <path
                                class="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            />
                        </svg>
                        <svg
                            v-if="!isSending"
                            class="flex h-5 w-5 text-blue-50 items-center transform rotate-90 tts-button-text"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                            />
                        </svg>
                    </button>
                </div>
            </div>
            <p
                v-if="can_moderate && someoneIsTyping"
                class="text-base text-gray-600 animate-bounce font-medium -mt-2"
                style="margin-left: 2px"
            >
                &nbsp;&hellip;&hellip;
            </p>
        </section>
    </section>
</template>

<style>
.overflow-y-scroll::-webkit-scrollbar,
.overflow-x-scroll::-webkit-scrollbar,
.overflow-y-auto::-webkit-scrollbar,
.overflow-x-auto::-webkit-scrollbar,
.overflow-auto::-webkit-scrollbar {
    display: none;
}
.overflow-x-scroll,
.overflow-y-scroll,
.overflow-y-auto,
.overflow-x-auto,
.overflow-auto {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}
.chat-fade-enter-active {
    transition: all 0.4s ease-out;
}
.chat-fade-enter-from {
    opacity: 0;
    transform: translateY(-12px);
}
.chat-fade-move {
    transition: transform 0.3s ease;
}
</style>

<script>
import moment from "moment";
// import VueChatScroll from "vue-chat-scroll";
import Swal from "sweetalert2";
export default {
    mounted() {
        this.getChats();
        let self = this;
        Echo.join("chats-" + this.pusher)
            .listen(".new-chat", (event) => {
                if (event.chat.deleted_at) {
                    self.chats = self.chats.filter(
                        (u) => u.id != event.chat.id
                    );
                } else if (self.pendingChatId !== event.chat.id) {
                    self.chats.unshift(event.chat);
                    self.trimChats();
                    self.scrollToTop();
                } else {
                    self.pendingChatId = null;
                }
                if (event.chat.r) {
                    Eventing.fire("recordingStarted");
                }
            })
            .listenForWhisper("typing", (e) => {
                if (self.can_moderate) {
                    self.someoneIsTyping = true;
                    setTimeout(() => {
                        self.someoneIsTyping = false;
                    }, 3000);
                }
            })
            .listen(".clear-chat", (event) => {
                self.chats = [];
            })
            .listen(".toggle-chat", (event) => {
                self.chatBoxStatus = event.status;
            })
            .listen(".redirect-user", (event) => {
                if (event.url == "home") {
                    self.$router.replace({ name: "home" });
                } else {
                    self.$router.replace({
                        name: "room",
                        params: { slug: event.url },
                    });
                }
            });
        Eventing.listen("showPinnedChats", () => (this.showPinnedChats = true));
        Eventing.listen(
            "showNormalChats",
            () => (this.showPinnedChats = false)
        );
        this.lang = document.documentElement.lang.substr(0, 2);
        if (this.chatbox == "pinned" || this.chatbox == "pinned-full") {
            this.showPinnedChats = true;
            Eventing.listen("refreshPinnedChats", () => this.getChats());
        }
    },
    components: {
        // VueChatScroll,
    },
    created() {
        try {
            if (
                document.head.querySelector('meta[name="is_moderator"]')
                    .content == "true"
            ) {
                this.isModerator = true;
            }
        } catch (error) {}
    },
    props: [
        "room",
        "workshop",
        "pusher",
        "users",
        "tenant",
        "can_moderate",
        "chatbox",
        "backstage",
    ],
    data() {
        return {
            lang: "en",
            isLoading: true,
            chats: [],
            message: "",
            chatOption: null,
            isSending: false,
            showPinnedChats: false,
            chatBoxStatus: "open",
            someoneIsTyping: false,
            isModerator: false,
            pendingChatId: null,
        };
    },
    beforeDestroy() {
        Echo.leave("chats-" + this.pusher);
    },
    methods: {
        isTyping: _.debounce(function (e) {
            let self = this;
            console.info("typing");
            let channel = Echo.join("chats-" + this.pusher);
            console.info("isTyping");
            channel.whisper("typing", {
                user: "Username",
                typing: true,
            });
        }, 300),
        async getChats() {
            let self = this;
            axios
                .get(
                    "/api/chats?room=" +
                        this.room +
                        "&workshop=" +
                        this.workshop
                )
                .then((response) => {
                    this.chats = response.data.data.reverse().slice(0, 150);
                    this.chatBoxStatus =
                        response.data.chat_open == true ? "open" : "closed";
                    if (this.chatBoxStatus != "open") {
                        Eventing.fire("chatIsClosed");
                    }
                    self.isLoading = false;
                    document.getElementById("message").focus();
                })
                .catch((error) => {
                    if (error.response.status == 500) {
                        // alert("Error: " + error.response.status);
                        self.chats = [];
                    }
                });
        },
        pinChat(chat) {
            let self = this;
            self.chatOption = false;
            Swal.fire({
                title: chat.is_pinned
                    ? self.t("tts.chats.unpin-title")
                    : self.t("tts.chats.pin-title"),
                // text: chat.is_pinned
                //     ? "Are you sure you want to unpin this message?"
                //     : "Are you sure you want to pin this message?",
                text: "",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    chat.is_pinned = !chat.is_pinned;
                    axios
                        .put("/api/chats/" + chat.id, {
                            pin: true,
                        })
                        .then((response) => {
                            Eventing.fire("refreshPinnedChats");
                        })
                        .catch((error) => {});
                }
            });
        },
        deleteChat(chat) {
            let self = this;
            self.chatOption = false;
            Swal.fire({
                title: self.t("tts.chats.delete-message"),
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    chat.is_pinned = true;
                    chat.message = "...";
                    axios
                        .delete("/api/chats/" + chat.id)
                        .then((response) => {
                            Eventing.fire("refreshPinnedChats");
                        })
                        .catch((error) => {});
                }
            });
        },
        sendNotification(chat) {
            let self = this;
            self.chatOption = false;
            Swal.fire({
                title: self.t(
                    "chats.send-notification-title",
                    "Notificatie sturen"
                ),
                text: self.t(
                    "chats.send-notification.",
                    "Wilt u :value een Notificatie sturen?",
                    chat.user.name
                ),
                // "Wilt u '" +
                // chat.user.name +
                // "' een persoonlijke notificatie sturen?",
                icon: "info",
                input: "text",
                inputPlaceholder: self.t(
                    "chats.send-notification.placeholder",
                    "Bericht voor uitgenodigde..."
                ),
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .put("/api/chats/" + chat.id, {
                            notificon: result.value,
                        })
                        .then((response) => {
                            // chat.is_invited = true;
                            Eventing.fire("refreshPinnedChats");
                        })
                        .catch((error) => {
                            if (error.response) {
                                if (error.response.status == 409) {
                                }
                            }
                        });
                }
            });
        },

        joinTalk(chat) {
            let self = this;
            self.chatOption = false;
            Swal.fire({
                // title: "Uitnodigen voor gesprek",
                title: self.t("chats.send-invite-title", "Notificatie sturen"),
                text: self.t(
                    "chats.send-invite",
                    "Wilt u :value uitnodigen om aan dit gesprek deel te nemen?",
                    chat.user.name
                ),

                icon: "warning",
                // input: "text",
                // inputPlaceholder: "Bericht voor uitgenodigde...",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .put("/api/chats/" + chat.id, {
                            inviteTalk: true,
                            message: result.value,
                        })
                        .then((response) => {
                            chat.is_invited = true;
                            // chat.is_pinned = true;
                            Eventing.fire("refreshPinnedChats");
                        })
                        .catch((error) => {
                            if (error.response) {
                                if (error.response.status == 409) {
                                    chat.is_invited = false;
                                }
                            }
                        });
                }
            });
        },

        fetchBack(chat) {
            let self = this;
            self.chatOption = false;
            Swal.fire({
                // title: "Uitnodigen voor gesprek",
                title: self.t("chats.fetch-from-backstage", "Backstage"),
                text: self.t(
                    "chats.back-backstage-invite",
                    "Wilt u :value terughalen uit de backstage?",
                    chat.user.name
                ),

                icon: "warning",
                // input: "text",
                // inputPlaceholder: "Bericht voor uitgenodigde...",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .put("/api/chats/" + chat.id, {
                            fetchBack: true,
                            message: result.value,
                        })
                        .then((response) => {
                            chat.is_invited = false;
                            // chat.is_pinned = true;
                            Eventing.fire("refreshPinnedChats");
                        })
                        .catch((error) => {
                            if (error.response) {
                                if (error.response.status == 409) {
                                    chat.is_invited = false;
                                }
                            }
                        });
                }
            });
        },
        blockUser(chat) {
            let self = this;
            self.chatOption = false;
            Swal.fire({
                title: self.t("chats.block-user", "Blokkeer gebruiker?"),
                text: self.t(
                    "chats.block-user-text",
                    "Wilt u :value de mogelijkheid om deel te nemen in de chat ontnemen? Dit kan niet ongedaan worden gemaakt",
                    chat.user.name
                ),

                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .put("/api/chats/" + chat.id, {
                            blockUser: true,
                        })
                        .then((response) => {
                            chat.user.is_blocked = true;
                            // chat.is_invited = false;
                            Eventing.fire("refreshPinnedChats");
                        })
                        .catch((error) => {
                            if (error.response) {
                            }
                        });
                }
            });
        },
        newChat() {
            let self = this;
            if (!self.isSending && self.message.length > 1) {
                self.isSending = true;
                axios
                    .post("/api/chats", {
                        message: self.message,
                        room: self.room,
                        workshop: self.workshop,
                    })
                    .then((response) => {
                        self.message = null;
                        self.pendingChatId = response.data.data.id;
                        self.chats.unshift(response.data.data);
                        self.trimChats();
                        self.isSending = false;
                        self.scrollToTop();
                    })
                    .catch((error) => {
                        if (error.response) {
                            // alert("Error: " + error.response.status);
                            if (error.response.status == 409) {
                                Swal.fire(
                                    self.t(
                                        "chats.blocked.failue",
                                        "Niet gelukt"
                                    ),
                                    self.t(
                                        "chats.blocked.error",
                                        "Uw mogelijkheid om deel te nemen aan de chat is geblokkeerd"
                                    ),
                                    "warning"
                                );
                                self.chatBoxStatus = "closed";
                            }
                        }
                        self.isSending = false;
                    });
            } else {
                setTimeout(() => (self.isSending = false), 10000);
            }
        },
        scrollToTop() {
            this.$nextTick(() => {
                if (this.$refs.chatList) {
                    this.$refs.chatList.scrollTo({ top: 0, behavior: 'smooth' });
                }
            });
        },
        trimChats() {
            if (this.chats.length > 150) {
                this.chats.length = 150;
            }
        },
    },
    computed: {
        allChats() {
            var self = this;
            if (this.showPinnedChats) {
                return this.chats.filter(function (u) {
                    return u.is_pinned;
                });
            } else {
                return this.chats.slice(0, 100);
            }
        },
    },
};
</script>
